export const SUPPORTED_BANNER_LANGUAGES = [
  { code: "en", label: "İngilizce" },
  { code: "tr", label: "Türkçe" },
];

export function resolveLanguageSelection(domainSettings) {
  const persistedCodes = Object.keys(domainSettings?.bannerSettings || {});
  const configuredDefault = domainSettings?.defaultLanguage;
  const activeCode = persistedCodes.length === 0
    ? ""
    : persistedCodes.includes(configuredDefault)
      ? configuredDefault
      : persistedCodes[0];

  return {
    activeCode,
    persistedCodes,
    options: persistedCodes
      .map((code) => SUPPORTED_BANNER_LANGUAGES.find((language) => language.code === code))
      .filter(Boolean),
  };
}
